var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreKebab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/More"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.41671 10.8334C6.61332 10.8334 7.58337 11.8034 7.58337 13C7.58337 14.1967 6.61332 15.1667 5.41671 15.1667C4.22009 15.1667 3.25004 14.1967 3.25004 13C3.25004 11.8034 4.22009 10.8334 5.41671 10.8334Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 10.8334C14.1966 10.8334 15.1666 11.8034 15.1666 13C15.1666 14.1967 14.1966 15.1667 13 15.1667C11.8033 15.1667 10.8333 14.1967 10.8333 13C10.8333 11.8034 11.8033 10.8334 13 10.8334Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5833 10.8334C21.78 10.8334 22.75 11.8034 22.75 13C22.75 14.1967 21.78 15.1667 20.5833 15.1667C19.3867 15.1667 18.4167 14.1967 18.4167 13C18.4167 11.8034 19.3867 10.8334 20.5833 10.8334Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreKebab);
export default __webpack_public_path__ + "static/media/MoreKebab.e282dabd2a3f6ce722d9f44da24035fd.svg";
export { ForwardRef as ReactComponent };